var _path, _g, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "topBottom",
    width: 99.999,
    height: 69.821,
    viewBox: "0 0 26.458 18.474",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bottom",
    transform: "translate(0 -.047247)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bottomBackground",
    d: "m0 9.2604h26.458v9.2604h-26.458z",
    fill: "#30865a",
    strokeWidth: 0.95972
  })), /*#__PURE__*/React.createElement("g", {
    id: "bottomLine",
    transform: "translate(-58.67,-176.51)",
    strokeWidth: ".099666px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "bottom line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.902 192.23c0.80372 0 1.2407-0.47219 1.2407-1.306v-0.0653c0-0.93432-0.49228-1.2206-0.96948-1.2206-0.34158 0-0.57767 0.0954-0.76856 0.21097h-0.02512v-1.2709h-0.38679v3.5163c0.22102 0.0854 0.61786 0.13563 0.90921 0.13563zm0.02009-0.32149c-0.25116 0-0.42698-0.0402-0.54251-0.0904v-1.6928c0.1306-0.0603 0.36167-0.16074 0.61786-0.16074 0.50232 0 0.74344 0.22604 0.74344 0.91925v0.10046c0 0.7133-0.37172 0.92428-0.81879 0.92428z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.699 192.22c0.67311 0 1.1353-0.47218 1.1353-1.2659v-0.0703c0-0.78865-0.42698-1.2458-1.1302-1.2458-0.67311 0-1.1302 0.47218-1.1302 1.2608v0.0753c0 0.79367 0.42195 1.2458 1.1252 1.2458zm0.01005-0.31646c-0.41693 0-0.74344-0.22605-0.74344-0.91926v-0.12558c0-0.58269 0.2813-0.90418 0.73339-0.90418 0.40688 0 0.74344 0.22605 0.74344 0.91925v0.12558c0 0.58772-0.2813 0.90419-0.73339 0.90419z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.197 192.2c0.216 0 0.32149-0.0553 0.42195-0.10046v-0.26121c-0.10046 0.0301-0.216 0.0452-0.32149 0.0452-0.28632 0-0.3667-0.0954-0.3667-0.33656v-1.5472h0.63795v-0.31646h-0.63795v-0.59274h-0.38177v0.59274h-0.35665v0.31646h0.35665v1.6074c0 0.42195 0.25618 0.59274 0.648 0.59274z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.904 192.2c0.216 0 0.32149-0.0553 0.42195-0.10046v-0.26121c-0.10046 0.0301-0.216 0.0452-0.32149 0.0452-0.28632 0-0.3667-0.0954-0.3667-0.33656v-1.5472h0.63795v-0.31646h-0.63795v-0.59274h-0.38177v0.59274h-0.35665v0.31646h0.35665v1.6074c0 0.42195 0.25618 0.59274 0.648 0.59274z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.841 192.22c0.67311 0 1.1353-0.47218 1.1353-1.2659v-0.0703c0-0.78865-0.42698-1.2458-1.1302-1.2458-0.67311 0-1.1302 0.47218-1.1302 1.2608v0.0753c0 0.79367 0.42195 1.2458 1.1252 1.2458zm0.01005-0.31646c-0.41693 0-0.74344-0.22605-0.74344-0.91926v-0.12558c0-0.58269 0.2813-0.90418 0.73339-0.90418 0.40688 0 0.74344 0.22605 0.74344 0.91925v0.12558c0 0.58772-0.2813 0.90419-0.73339 0.90419z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.55 192.17h0.38177v-2.0244c0.20093-0.0954 0.42195-0.18084 0.63293-0.18084 0.33153 0 0.45209 0.12558 0.45209 0.42698v1.7782h0.38177v-1.8586c0-0.0603-5e-3 -0.10548-0.01507-0.16576 0.23609-0.10549 0.44707-0.18084 0.64297-0.18084 0.33656 0 0.45712 0.12558 0.45712 0.42698v1.7782h0.37674v-1.8586c0-0.48223-0.25116-0.67813-0.68316-0.67813-0.2813 0-0.57265 0.10046-0.8439 0.27627h-0.02009c-0.11553-0.18585-0.31646-0.27627-0.59776-0.27627s-0.54753 0.11553-0.7786 0.26121h-0.0201v-0.216h-0.3667z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.917 192.17h0.38679v-3.5966h-0.38679z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.06 192.17h0.38177v-2.4865h-0.38177zm-5e-3 -2.9888h0.39181v-0.40186h-0.39184z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.183 192.17h0.38177v-2.0244c0.20595-0.0954 0.46716-0.18084 0.70325-0.18084 0.39684 0 0.50232 0.12558 0.50232 0.42698v1.7782h0.38177v-1.8586c0-0.48223-0.23609-0.67813-0.72335-0.67813-0.30642 0-0.6279 0.11051-0.85897 0.26121h-0.02009v-0.216h-0.3667z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.896 192.22c0.40186 0 0.68818-0.12558 0.83888-0.23107v-0.28632c-0.22604 0.10549-0.44707 0.18586-0.7786 0.18586-0.53246 0-0.82884-0.24112-0.84893-0.864h1.6979v-0.216c0-0.77358-0.32149-1.1704-1.0046-1.1704-0.57265 0-1.085 0.38679-1.085 1.2558v0.0703c0 0.7786 0.39684 1.2558 1.1805 1.2558zm-0.10549-2.2705c0.40688 0 0.61284 0.22604 0.61284 0.76855h-1.296c0.04019-0.58772 0.37172-0.76855 0.68316-0.76855z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bottomLineFinal",
    transform: "translate(-58.67,-176.51)",
    strokeWidth: ".099666px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "bottom line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.902 192.23c0.80372 0 1.2407-0.47219 1.2407-1.306v-0.0653c0-0.93432-0.49228-1.2206-0.96948-1.2206-0.34158 0-0.57767 0.0954-0.76856 0.21097h-0.02512v-1.2709h-0.38679v3.5163c0.22102 0.0854 0.61786 0.13563 0.90921 0.13563zm0.02009-0.32149c-0.25116 0-0.42698-0.0402-0.54251-0.0904v-1.6928c0.1306-0.0603 0.36167-0.16074 0.61786-0.16074 0.50232 0 0.74344 0.22604 0.74344 0.91925v0.10046c0 0.7133-0.37172 0.92428-0.81879 0.92428z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.699 192.22c0.67311 0 1.1353-0.47218 1.1353-1.2659v-0.0703c0-0.78865-0.42698-1.2458-1.1302-1.2458-0.67311 0-1.1302 0.47218-1.1302 1.2608v0.0753c0 0.79367 0.42195 1.2458 1.1252 1.2458zm0.01005-0.31646c-0.41693 0-0.74344-0.22605-0.74344-0.91926v-0.12558c0-0.58269 0.2813-0.90418 0.73339-0.90418 0.40688 0 0.74344 0.22605 0.74344 0.91925v0.12558c0 0.58772-0.2813 0.90419-0.73339 0.90419z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.197 192.2c0.216 0 0.32149-0.0553 0.42195-0.10046v-0.26121c-0.10046 0.0301-0.216 0.0452-0.32149 0.0452-0.28632 0-0.3667-0.0954-0.3667-0.33656v-1.5472h0.63795v-0.31646h-0.63795v-0.59274h-0.38177v0.59274h-0.35665v0.31646h0.35665v1.6074c0 0.42195 0.25618 0.59274 0.648 0.59274z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.904 192.2c0.216 0 0.32149-0.0553 0.42195-0.10046v-0.26121c-0.10046 0.0301-0.216 0.0452-0.32149 0.0452-0.28632 0-0.3667-0.0954-0.3667-0.33656v-1.5472h0.63795v-0.31646h-0.63795v-0.59274h-0.38177v0.59274h-0.35665v0.31646h0.35665v1.6074c0 0.42195 0.25618 0.59274 0.648 0.59274z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.841 192.22c0.67311 0 1.1353-0.47218 1.1353-1.2659v-0.0703c0-0.78865-0.42698-1.2458-1.1302-1.2458-0.67311 0-1.1302 0.47218-1.1302 1.2608v0.0753c0 0.79367 0.42195 1.2458 1.1252 1.2458zm0.01005-0.31646c-0.41693 0-0.74344-0.22605-0.74344-0.91926v-0.12558c0-0.58269 0.2813-0.90418 0.73339-0.90418 0.40688 0 0.74344 0.22605 0.74344 0.91925v0.12558c0 0.58772-0.2813 0.90419-0.73339 0.90419z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.55 192.17h0.38177v-2.0244c0.20093-0.0954 0.42195-0.18084 0.63293-0.18084 0.33153 0 0.45209 0.12558 0.45209 0.42698v1.7782h0.38177v-1.8586c0-0.0603-5e-3 -0.10548-0.01507-0.16576 0.23609-0.10549 0.44707-0.18084 0.64297-0.18084 0.33656 0 0.45712 0.12558 0.45712 0.42698v1.7782h0.37674v-1.8586c0-0.48223-0.25116-0.67813-0.68316-0.67813-0.2813 0-0.57265 0.10046-0.8439 0.27627h-0.02009c-0.11553-0.18585-0.31646-0.27627-0.59776-0.27627s-0.54753 0.11553-0.7786 0.26121h-0.0201v-0.216h-0.3667z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.917 192.17h0.38679v-3.5966h-0.38679z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.06 192.17h0.38177v-2.4865h-0.38177zm-5e-3 -2.9888h0.39181v-0.40186h-0.39184z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.183 192.17h0.38177v-2.0244c0.20595-0.0954 0.46716-0.18084 0.70325-0.18084 0.39684 0 0.50232 0.12558 0.50232 0.42698v1.7782h0.38177v-1.8586c0-0.48223-0.23609-0.67813-0.72335-0.67813-0.30642 0-0.6279 0.11051-0.85897 0.26121h-0.02009v-0.216h-0.3667z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.896 192.22c0.40186 0 0.68818-0.12558 0.83888-0.23107v-0.28632c-0.22604 0.10549-0.44707 0.18586-0.7786 0.18586-0.53246 0-0.82884-0.24112-0.84893-0.864h1.6979v-0.216c0-0.77358-0.32149-1.1704-1.0046-1.1704-0.57265 0-1.085 0.38679-1.085 1.2558v0.0703c0 0.7786 0.39684 1.2558 1.1805 1.2558zm-0.10549-2.2705c0.40688 0 0.61284 0.22604 0.61284 0.76855h-1.296c0.04019-0.58772 0.37172-0.76855 0.68316-0.76855z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "top"
  }, /*#__PURE__*/React.createElement("path", {
    id: "topBackground",
    d: "m1.3123e-6 0h26.458v9.2604h-26.458z",
    fill: "#db865a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "topLine",
    d: "m1.3123e-6 0v9.2603h26.458v-9.2603zm14.628 1.3198h0.59015v5.4863h-0.59015zm1.7358 0.31419h0.5979v0.6134h-0.5979zm-14.497 0.47542h0.58239v0.90381h0.97305v0.48318h-0.97305v2.36c0 0.36779 0.12238 0.51315 0.55914 0.51315 0.16091 0 0.33715-0.023246 0.4904-0.069246v0.39893c-0.15325 0.06895-0.31387 0.15296-0.64335 0.15296-0.59766 0-0.98855-0.26069-0.98855-0.90433v-2.4515h-0.54414v-0.48318h0.54414zm3.9507 0.82734c1.0727 0 1.7239 0.69714 1.7239 1.9001v0.10749c0 1.2106-0.70489 1.9311-1.7316 1.9311-1.0727 0-1.7161-0.69-1.7161-1.9006v-0.11472c0-1.203 0.69714-1.9234 1.7239-1.9234zm4.3232 0c0.8352 0 1.5554 0.45976 1.5554 1.8696v0.099734c0 1.3869-0.6664 1.9694-1.7161 1.9694-0.43674 0-0.75903-0.13061-0.97358-0.25321v1.3182h-0.58962v-4.9273h0.56689v0.30644h0.030487c0.23753-0.21455 0.63613-0.38293 1.1265-0.38293zm9.8437 0c0.74326 0 1.1038 0.29895 1.1038 1.0346v2.835h-0.58239v-2.7125c0-0.45973-0.16103-0.6511-0.76636-0.6511-0.36012 0-0.75863 0.13037-1.0728 0.27596v3.0876h-0.58239v-3.8002h0.55964v0.32916h0.03049c0.35247-0.22987 0.84258-0.39843 1.31-0.39843zm3.6179 0c1.0421 0 1.5327 0.60539 1.5327 1.7854v0.32969h-2.59c0.03065 0.95013 0.48278 1.3177 1.295 1.3177 0.50572 0 0.84271-0.12279 1.1875-0.28371v0.43666c-0.22987 0.16091-0.6665 0.35295-1.2795 0.35295-1.1953 0-1.8004-0.72797-1.8004-1.9156v-0.10749c0-1.3256 0.78115-1.9156 1.6547-1.9156zm-7.231 0.07648h0.58239v3.793h-0.58239zm7.2159 0.39843c-0.47505 0-0.98101 0.27604-1.0423 1.1725h1.9771c0-0.82753-0.31416-1.1725-0.93481-1.1725zm-17.777 0.00775c-0.6896 0-1.1188 0.4904-1.1188 1.3792v0.19172c0 1.0574 0.49831 1.402 1.1343 1.402 0.6896 0 1.1188-0.48273 1.1188-1.3792v-0.1912c0-1.0574-0.51363-1.4025-1.1343-1.4025zm4.1775 0.015502c-0.44442 0-0.80456 0.15335-0.9808 0.27596v2.4133c0.17623 0.14559 0.52138 0.2682 0.91984 0.2682 0.72027 0 1.157-0.38287 1.157-1.402v-0.15348c0-1.0727-0.39878-1.402-1.096-1.402z",
    fill: "#3086e8",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    id: "topOverlay",
    d: "m1.3123e-6 0h26.458v9.2604h-26.458z",
    fill: "#db865a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "topBackgroundFinal",
    d: "m1.1112e-6 1e-7h26.458v9.2604h-26.458z",
    fill: "#db865a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "topLineFinal",
    d: "m1.1112e-6 5.01e-5v9.2603h26.458v-9.2603zm14.628 1.3198h0.59015v5.4863h-0.59015zm1.7358 0.31419h0.5979v0.6134h-0.5979zm-14.497 0.47542h0.58239v0.90381h0.97305v0.48318h-0.97305v2.36c0 0.36779 0.12238 0.51315 0.55914 0.51315 0.16091 0 0.33715-0.02325 0.4904-0.06925v0.39893c-0.15325 0.06895-0.31387 0.15296-0.64335 0.15296-0.59766 0-0.98855-0.26069-0.98855-0.90433v-2.4515h-0.54414v-0.48318h0.54414zm3.9507 0.82734c1.0727 0 1.7239 0.69714 1.7239 1.9001v0.10749c0 1.2106-0.70489 1.9311-1.7316 1.9311-1.0727 0-1.7161-0.69-1.7161-1.9006v-0.11472c0-1.203 0.69714-1.9234 1.7239-1.9234zm4.3232 0c0.8352 0 1.5554 0.45976 1.5554 1.8696v0.09973c0 1.3869-0.6664 1.9694-1.7161 1.9694-0.43674 0-0.75903-0.13061-0.97358-0.25321v1.3182h-0.58962v-4.9273h0.56689v0.30644h0.030487c0.23753-0.21455 0.63613-0.38293 1.1265-0.38293zm9.8437 0c0.74326 0 1.1038 0.29895 1.1038 1.0346v2.835h-0.58239v-2.7125c0-0.45973-0.16103-0.6511-0.76636-0.6511-0.36012 0-0.75863 0.13037-1.0728 0.27596v3.0876h-0.58239v-3.8002h0.55964v0.32916h0.03049c0.35247-0.22987 0.84258-0.39843 1.31-0.39843zm3.6179 0c1.0421 0 1.5327 0.60539 1.5327 1.7854v0.32969h-2.59c0.03065 0.95013 0.48278 1.3177 1.295 1.3177 0.50572 0 0.84271-0.12279 1.1875-0.28371v0.43666c-0.22987 0.16091-0.6665 0.35295-1.2795 0.35295-1.1953 0-1.8004-0.72797-1.8004-1.9156v-0.10749c0-1.3256 0.78115-1.9156 1.6547-1.9156zm-7.231 0.07648h0.58239v3.793h-0.58239zm7.2159 0.39843c-0.47505 0-0.98101 0.27604-1.0423 1.1725h1.9771c0-0.82753-0.31416-1.1725-0.93481-1.1725zm-17.777 0.00775c-0.6896 0-1.1188 0.4904-1.1188 1.3792v0.19172c0 1.0574 0.49831 1.402 1.1343 1.402 0.6896 0 1.1188-0.48273 1.1188-1.3792v-0.1912c0-1.0574-0.51363-1.4025-1.1343-1.4025zm4.1775 0.015502c-0.44442 0-0.80456 0.15335-0.9808 0.27596v2.4133c0.17623 0.14559 0.52138 0.2682 0.91984 0.2682 0.72027 0 1.157-0.38287 1.157-1.402v-0.15348c0-1.0727-0.39878-1.402-1.096-1.402z",
    fill: "#3086e8",
    strokeWidth: 0.26458
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "topOverlayFinal",
    d: "m-1.671e-4 9.2132h26.458v9.2604h-26.458z",
    fill: "#d40000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "centerLine",
    d: "m-1.6648e-4 9.1045h26.458v0.26458h-26.458z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBottom);
export default __webpack_public_path__ + "static/media/top-bottom.6858c1a1.svg";
export { ForwardRef as ReactComponent };